import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Path } from '@core/enums/path.enum';
import { AuthGuard, NoAuthGuard, RoleGuard } from '@core/guards';
import { NotFoundPage } from '@public/pages/not-found/not-found.page';
import { LayoutComponent } from './layout/components/layout/layout.component';
import { DeviceComponent } from './static/device/device.component';
import { QrCodeComponent } from './pages/qr-code/qr-code/qr-code.component';
import { CareersComponent } from './static/careers/careers.component';

const routes: Routes = [
  // Public
  {
    path: Path.Home,
    component: LayoutComponent,
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },
  // Auth
  {
    path: Path.Home,
    component: LayoutComponent,
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: Path.Static,
    component: LayoutComponent,
    loadChildren: () =>
      import('./static/static.module').then((m) => m.StaticModule),
  },
  {
    path: 'static/device/:id',
    component: DeviceComponent,
  },
  {
    path: Path.CAREERS,
    component: CareersComponent,
  },
  {
    path: Path.App,
    children: [
      {
        path: Path.Profile,
        component: LayoutComponent,
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: Path.Filmmaker,
        component: LayoutComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['FILM_MAKER'] },
        loadChildren: () =>
          import('./pages/filmmaker/filmmaker.module').then(
            (m) => m.FilmmakerModule,
          ),
      },
      {
        path: '',
        component: LayoutComponent,
        loadChildren: () =>
          import('./pages/movie-detail/movie-detail.module').then(
            (m) => m.MovieDetailModule,
          ),
      },
      {
        path: Path.I_AM_FILM_MAKER,
        component: LayoutComponent,
        loadChildren: () =>
          import('./pages/i-am-filmmaker/i-am-filmmaker.module').then(
            (m) => m.IAmFilmmakerModule,
          ),
      },
      {
        path: Path.SEARCH,
        component: LayoutComponent,
        loadChildren: () =>
          import('./pages/search/search.module').then((m) => m.SearchModule),
      },
    ],
  },
  {
    path: Path.QR_CODE,
    component: QrCodeComponent,
    loadChildren: () =>
      import('./pages/qr-code/qr-code.module').then((m) => m.QRModule),
  },
  // Payment bridge for filmmaker fee payments redirected from filmfactory domain
  // No auth guard — sessionId is a one-time Cashfree token
  {
    path: 'film-maker/payment/:sessionId',
    loadComponent: () =>
      import('./pages/film-maker-payment-bridge/payment-bridge.component').then(
        (m) => m.PaymentBridgeComponent,
      ),
  },
  // Not found page
  {
    path: '**',
    component: NotFoundPage,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledBlocking',
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
